import { ChatHero } from "../components/features/ChatHero"
import { StaticHighlights } from "../components/features/StaticHighlights"

export function Home() {
  return (
    <div>
      <ChatHero />
      <StaticHighlights />
    </div>
  )
}
